import { X } from 'lucide-react';
import { ImageWithFallback } from '../figma/ImageWithFallback';

interface BrandedHeaderProps {
  onMinimize?: () => void;
  onClose: () => void;
}

export function BrandedHeader({ onClose }: BrandedHeaderProps) {
  return (
    <div className="bg-gradient-to-r from-[#0B3D91] to-[#1E5BB8] border-b border-[#0B3D91]/20 px-5 py-4 shadow-lg">
      <div className="flex items-center justify-between">
        {/* Left: EZ Learn Logo and Title */}
        <div className="flex items-center gap-3">
          <div className="flex items-center bg-white px-3 py-1.5 rounded-lg">
            <ImageWithFallback
              src="https://ez-learn.global/wp-content/uploads/2023/04/logo.svg"
              alt="EZ Learn Global Logo"
              className="h-8 w-auto object-contain"
            />
          </div>
          <div className="h-10 w-px bg-white/30"></div>
          <div>
            <div className="text-sm font-semibold text-white">EZ-learn Assistant</div>
          </div>
        </div>

        {/* Right: Minimize and Close */}
        <div className="flex items-center gap-1">
          <button
            onClick={onClose}
            className="text-white/80 hover:text-white hover:bg-white/10 rounded-lg p-1.5 transition-all"
            aria-label="Close chat"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}